import { render, staticRenderFns } from "./tdColSafeHTML.vue?vue&type=template&id=502e2a8c&"
import script from "./tdColSafeHTML.vue?vue&type=script&lang=js&"
export * from "./tdColSafeHTML.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports